<template>
  <div class="footerBG">
    <div class="footerBox">
      <img class="logo" src="../assets/img/cp1-logo.svg" alt="">
      <div>
        <ul class="items">
          <li @click="TermsofUse">{{ contList.menus[contType][0] }}</li>
          <li @click="AMLStatement">{{ contList.menus[contType][1] }}</li>
          <li @click="CookiePolicy">{{ contList.menus[contType][2] }}</li>
          <li @click="PrivacyPolicy">{{ contList.menus[contType][3] }}</li>
        </ul>
      </div>
      <div class="footerBoxR">
        <div class="footT1">{{ contList.bottom[contType] }}：cs@suntone.com</div>
        <div class="footT2">Copyright © {{ copyRight }} Suntone. All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      copyRight: '',
      contList: {
        bottom: {
          z: '联系我们',
          f: '聯繫我們',
          e: 'Contact Us',
        },
        menus: {
          z: [
            '使用条款',
            '反洗钱与反恐融资声明',
            'Cookies政策',
            '个人信息收集声明'
          ],
          f: [
            '使用條款',
            '反洗錢與反恐融資聲明',
            'Cookies政策',
            '個人資訊收集聲明'
          ],
          e: [
            'Terms of Use',
            'AML Statement',
            'Cookies Policy',
            'Privacy Policy'
          ],
        }
      },
      contType: 'z'
    }
  },
  mounted() {
    this.copyRight = new Date().getFullYear();
    var that = this;
    this.contType = window.localStorage.getItem('language');
    window.addEventListener('setItemEvent', function (e) {
      if (e.key == 'language') {
        that.contType = e.newValue
      }
    })
  },
  methods: {
    TermsofUse() {
      this.$router.push("/TermsofUse");
    },
    AMLStatement() {
      this.$router.push("/AMLStatement");
    },
    CookiePolicy() {
      this.$router.push("/CookiePolicy");
    },
    PrivacyPolicy() {
      this.$router.push("/PrivacyPolicy");
    },
  },

}
</script>

<style lang="less" scoped>
.footerBG .items li {
  list-style: none;
  padding: 8px 5px;
  cursor: pointer;
}

.footerBG .items li:hover {
  border-bottom: 2px solid #2b82e9;
}

//响应式示例写法
@media screen and (max-width: 800px) {

  //手机尺寸
  .footerBG {
    width: 100%;
    height: 162px;
    background: #E6E6E6;
    display: flex;
    justify-content: center;
  }

  .footerBox {
    width: 100%;
    display: flex;
    padding-top: 30px;
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;
  }

  .logo {
    width: 134px;
    height: 37.4px;
  }

  .footT1 {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    text-align: center;
    margin-top: 16px;
  }

  .footT2 {
    color: #666;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    text-align: center;
    margin-top: 14px;
  }


}

@media screen and (min-width: 801px) {

  //大于手机使用
  .footerBG {
    width: 100%;
    height: 282px;
    background: #E6E6E6;
    display: flex;
    justify-content: center;
  }

  .footerBox {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    padding-top: 30px;
    box-sizing: border-box;
  }

  .logo {
    width: 200px;
    height: 56px;
  }

  .footT1 {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
  }

  .footT2 {
    color: #666;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
  }
}
</style>